// 通用 复制成功 提示文案
export const copiedMessage = 'Copied Successfully !'

export const NETWORK_TIMEOUT = 'Your request has timed out. Please try again.'

export const PENDING_CANCEL = 'pending cancel'

// 验证码消息
export const getVerifyCodeMessage = (count) => {
  const unit = count === 1 ? 'time' : 'times'
  return `Code sent. You have ${count} ${unit} left to request another one.`
}

export const NO_MATCHES_AVAILABLE = 'Sorry, there are no matches currently available.'
export const COMMENTS_NOT_AVAILABLE = 'Sorry, Comments are not available for this match.'

// 通用错误提示文案
export const DEFAULT_ERROR_TEXT = 'Sorry, something went wrong. Please try again later.'

// 首充气泡文案
export const tooltipText = (percent) => `Up to ${percent} extra BONUS on the first deposit!`

// event ID 无效
export const NOT_AVAILABLE_MATCH = 'Sorry, this match is not available for viewing or betting. Please change another one.'

// bet
export const ALL_SELECTIONS_UNAVAILABLE = 'All Selections are unavailable now. Please try again later.'
export const ORDER_MAY_FAILED = 'Sorry, maybe your order has not been submitted successfully. To avoid unexpectedly repeating your bet, please check your "Bet History" first.'
export const EXTRA_BONUS_NOTE = 'The part of Winnings from vouchers will not get an Extra Bonus.'
export const UNAVAILABLE_WITH_BET_BUILDER = 'Multiple+ is unavailable with bet builder selections.'

export const NO_MATCHES_CHOOSE = 'No matches available. Please choose after ranges.'

// jackpot
export const MAXIMUM_COMBINATIONS = 'Maximum Combinations is 20,000. Please adjust your Selections'

// trade
export const INCLUDING_RECORDS_MESSAGE = 'Including records of some casino games except MCards older than 30 days and other records except Jackpot older than 180 days.'
export const NO_MORE_RECORDS_MESSAGE = 'No more records in the past 6 months (Only 30 days for most casino games. Note: MCards and Jackpot records are unlimited).'

export const MANUALLY_PROCESSING = 'Manually Processing (Result in 3 working days)'
export const POTENTIAL_RISKS_WARNING =
  'Your account is under the review of MSport due to some potential risks. To protect your financial safety, we will delay your withdrawals and hold the related balance. The reviewing process can last up to 3 days. Please wait patiently. Thanks for your cooperation.'

// verify
export const VERIFY_SECURITY_EMAIL = 'Verify by Security Email'
export const VERIFY_REGISTRATION_PHONE = 'Verify by registration phone number'
export const CORRECTLY_FILL_SMS = 'Please correctly fill in the SMS verification code sent to your registered mobile phone number.'
export const CORRECTLY_FILL_EMAIL = 'Please correctly fill in the Email verification code sent to your Security Email.'
export const DESCRIPTION_VERIFY_SECURITY_EMAIL =
  'MSport offers email verification. First you need to set up the Security Email. Then you can complete the verification by email. Click the button to bind your email.'
export const PAYMENT_REQUEST_ERROR = 'Sorry, your payment request has a problem. Please try using a different card or a card from a different bank. Thank you.'

export const TICKET_DELETED_WARNING = 'Sorry, running ticket cannot be deleted!'

export const ADDED_FAVOURITES = 'Added to My Favourites'
export const REMOVED_FAVOURITES = 'Removed from My Favourites'